import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import * as S from './LimitsSection.styles';
import { useLimitsList } from './hooks/useLimitsList';
import { LIMITS_SECTION_SKELETON_COUNT } from './LimitsSection.constants';
import { LimitsCard } from './components/LimitsCard/LimitsCard';
import { LimitsEmpty } from './components/LimitsEmpty/LimitsEmpty';
import { ROUTES } from '@/constants/routes';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { useResponsive } from '@/hooks/useResponsive';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const LimitsSection = () => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsive();
  const { loading, limits, hasLimits } = useLimitsList();

  const titleKey = isDesktop
    ? 'pages.cabinet.remaining_placements_by_categories'
    : 'pages.cabinet.remaining_placements_in_your_categories';

  function renderLimitsSkeleton() {
    return (
      <S.Grid>
        {Array.from({ length: LIMITS_SECTION_SKELETON_COUNT }, (_, index) => (
          <SkeletonLoader key={index} height={145} borderRadius={14} />
        ))}
      </S.Grid>
    );
  }

  function renderLimitsList() {
    return (
      <S.Grid>
        {limits.map(item => (
          <LimitsCard key={item.id} item={item} />
        ))}
      </S.Grid>
    );
  }

  function renderContent() {
    if (loading) {
      return renderLimitsSkeleton();
    }

    if (!hasLimits) {
      return <LimitsEmpty />;
    }

    return renderLimitsList();
  }

  return (
    <S.Box>
      <S.Title>{t(titleKey)}</S.Title>
      {renderContent()}
      <S.MoreInfo>
        <Trans
          i18nKey="pages.cabinet.placements_more_link"
          components={{
            link1: (
              <CustomLink target="_blank" href={ROUTES.limitsByCategory} />
            ),
          }}
        />
      </S.MoreInfo>
    </S.Box>
  );
};
